import styled from 'styled-components';

// This style should be placed here and no in './styles.js' because there,
// when importing this component, cyclics imports happen

const StyledThumbnail = styled.img`
  height: 80px;
  width: 80px;
`;

export default StyledThumbnail;
